/**
 * Classe responsável por gerenciar a criação do raio do stop
 * Created by adalto on 5/13/14.
 */


Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.MapLayerActions = Greenmile.Toolbar.MapLayerActions || {};

Greenmile.Toolbar.MapLayerActions.LayerRadius = (function () {

    function LayerRadius () {

        Greenmile.Toolbar.MapLayerActions.Base.apply(this, arguments);

        this.LAYER_NAME = 'radius_route';
        this.RESOURCE_LAYER = 'RouteDetail.ToolBar.Layers.RadiusStop';

        var instanceToDataClass = null;

        this.setInstanceToClassData = function (instance) {
            instanceToDataClass = instance;
        };

        this.afterClickOnCheckBox = function (element) {

            var _element = element.target;

            this.setLayerStatusOnLocalStorageByTagName(_element.checked);

            if (instanceToDataClass) {

                if (_element.checked) {
                    instanceToDataClass.drawRadiusFromStop();
                } else {
                    instanceToDataClass.removePositionRadius();
                }

            }

        };



    }

    return LayerRadius;

})();
